export const GET_AFFILIATE_REELS = "GET_AFFILIATE_REELS";
export const DELETE_AFFILIATE_REELS = "DELETE_AFFILIATE_REELS";
